import { createApp, watch, nextTick } from "vue";
import { store, mutations } from "@js/vue/store";
import { registerComponents } from "@js/vue/components";
import { registerDirectives } from "@js/vue/directives";
import { SplideSlide } from "@splidejs/vue-splide";

export function initializeApp() {
	/*
	 * Create the app
	 */
	const app = createApp({
		delimiters: ["${", "}"],
		setup() {
			return { store, mutations };
		},
	});

	app.config.errorHandler = (err, instance, info) => {
		console.error("Error:", err);
		console.log("Vue component:", instance);
		console.log("Additional info:", info);
	};

	// Register all components
	registerComponents(app);
	app.component("SplideSlide", SplideSlide);

	// Register all directives
	registerDirectives(app);

	/*
	 * Mount the app
	 */
	app.mount("#app");
}
